// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".b.b-icon_text[data-v-54ff405f]{justify-content:flex-start}.b.b-icon_text[data-v-54ff405f] svg{flex-shrink:0;width:24px;height:24px;margin-right:.5rem;--text-opacity:1;color:#171717;color:rgba(23,23,23,var(--text-opacity))}.b__title[data-v-54ff405f]{line-height:20px}@media (min-width:960px){.b.b-icon_text[data-v-54ff405f] svg{margin-right:.75rem}.b__title[data-v-54ff405f]{line-height:26px}}", ""]);
// Exports
module.exports = exports;
